// extracted by mini-css-extract-plugin
module.exports = {"send_wrapper":"SendMessage_send_wrapper__2K-qO","send":"SendMessage_send__2hUec","input":"SendMessage_input__NlKAV"};